import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProfileSettingsPage } from './profile-settings.page';

const routes: Routes = [
  {
    path: '',
    component: ProfileSettingsPage
  },
  {
    path: 'primary-info',
    loadChildren: () => import('./primary-info/primary-info.module').then( m => m.PrimaryInfoPageModule)
  },
  {
    path: 'account-info',
    loadChildren: () => import('./account-info/account-info.module').then( m => m.AccountInfoPageModule)
  },
  {
    path: 'contact-info',
    loadChildren: () => import('./contact-info/contact-info.module').then( m => m.ContactInfoPageModule)
  },
  {
    path: 'gallery-settings',
    loadChildren: () => import('./gallery-settings/gallery-settings.module').then( m => m.GallerySettingsPageModule)
  },
  {
    path: 'music-settings',
    loadChildren: () => import('./music-settings/music-settings.module').then( m => m.MusicSettingsPageModule)
  },
  {
    path: 'calendar-settings',
    loadChildren: () => import('./calendar-settings/calendar-settings.module').then( m => m.CalendarSettingsPageModule)
  },
  {
    path: 'specials-settings',
    loadChildren: () => import('./specials-settings/specials-settings.module').then( m => m.SpecialsSettingsPageModule)
  },
  {
    path: 'booking-info',
    loadChildren: () => import('./booking-info/booking-info.module').then( m => m.BookingInfoPageModule)
  },
  {
    path: 'video-archives-settings',
    loadChildren: () => import('./video-archives-settings/video-archives-settings.module').then( m => m.VideoArchivesSettingsPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfileSettingsPageRoutingModule {}
